// extracted by mini-css-extract-plugin
export var pillWrapper = "_p0-0";
export var showOverflow = "_p0-1";